<template>
	<div style="height: 500px;overflow: auto;">
		<el-form :model="from" :rules="rules" ref="from" label-width="100px">
			<div style="min-width: 1000px;">
				<el-row>
					<el-col :span="10">
						<el-form-item label="审批流名称" prop="name">
							<el-input v-model="from.name" placeholder="请输入审批流名称" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="类型" prop="type">
							<el-select v-model="from.type" placeholder="请选择类型" style="width: 100%;" filterable>
								<el-option v-for="item in $parent.$parent.typeList" :key="item.value"
									:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 
            <div style="width: 100%; border-left: 2px #006E4B solid; border-bottom: 1px #C8C9CC solid;">
                <span style="font-size: 16px; margin-left: 5px; line-height: 22px;">审批节点</span> -->
				<el-row style="padding: 0 20px;">
					<el-tabs v-model="activeName">
						<el-tab-pane label="审批节点" name="first">
							<el-row style="margin-top: 10px;">
								<el-col :span="8" style="padding-left: 5px; margin-top: 5px;"
									v-for="(item, index) in objestSize" :key="index">
									<div style="border: 1px #ebebeb solid;height: 220px;width: 315px;">
										<el-form :model="from.sysFlowDetails[index]" :rules="sysFlowDetailsRules"
											ref="sysFlowDetailsfrom">
											<el-row style="background-color: #f3f3f3; height: 40px;">
												<el-form-item>
													<span
														style="font-size: 15px; margin-left: 10px; line-height: 40px;">节点{{index + 1}}</span>
													<div
														style="display: inline-block; float: right; line-height: 30px; margin-right: 10px;">
														<i class="el-icon-close" style="margin-left: 10px;"
															@click="RemoveRecord(index)" v-show="index != 0"></i>
													</div>
												</el-form-item>
											</el-row>

											<el-row style="height: 80px;line-height: 80px;text-align: center;">
												<el-radio-group @change="spjdchange(index)"
													v-model="from.sysFlowDetails[index].is_leadership">
													<el-radio :label="1">指定人
													</el-radio>
													<el-radio :label="2">角色</el-radio>
													<el-radio :label="3">自选人
													</el-radio>
												</el-radio-group>
											</el-row>

											<el-row
												style="padding-bottom: 10px; margin-top: 10px; background-color: #fdfdfd;">
												<el-col :span="2">&nbsp;</el-col>
												<el-col :span="20">
													<el-form-item prop="ids"
														v-if="from.sysFlowDetails[index].is_leadership == 1">
														<el-select v-model="from.sysFlowDetails[index].ids" filterable
															clearable multiple collapse-tags placeholder="请选择指定人"
															style="width: 100%;">
															<el-option v-for="(user, userIndex) in userList"
																:key="userIndex" :label="user.staff_name"
																:value="user.staff_id">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item v-if="from.sysFlowDetails[index].is_leadership == 2"
														prop="ids">
														<el-select v-model="from.sysFlowDetails[index].ids" clearable
															multiple collapse-tags placeholder="请选择角色"
															style="width: 100%;">
															<el-option v-for="role in roleList" :key="role.id"
																:label="role.role_name" :value="role.id">
															</el-option>
														</el-select>
													</el-form-item>
												</el-col>
											</el-row>
										</el-form>
									</div>
								</el-col>
								<el-col :span="8">
									<div style=" width: 90px; border: 1px #f8f8f8 solid; margin-top: 5px; margin-left: 5px; text-align: center; background-color: #fdfdfd;"
										@click="AddRecord">
										<img style="height: 220px;width: 315px;" src="../../../../src/assets/审批+.png">
									</div>
								</el-col>
							</el-row>
						</el-tab-pane>

						<el-tab-pane label="审批条件" name="second">
							<el-row style="margin-top: 10px;">
								<el-col :span="8" style="padding-left: 5px; margin-top: 5px;"
									v-for="(item, index) in objestSize2" :key="index">
									<div style="border: 1px #ebebeb solid;height: 285px;width: 315px;">
										<el-form :model="from.sysFlowCriterias[index]" :rules="sysFlowCriteriasRules"
											ref="sysFlowCriteriasfrom2">
											<el-row style="background-color: #f3f3f3; height: 40px;">
												<el-form-item>
													<span
														style="font-size: 15px; margin-left: 10px; line-height: 40px;">审批条件{{
                                                                index +
                                                                1
                                                        }}</span>
													<div
														style="display: inline-block; float: right; line-height: 30px; margin-right: 10px;">
														<i class="el-icon-close" style="margin-left: 10px;"
															@click="RemoveRecord2(index)" v-show="index != 0"></i>
													</div>
												</el-form-item>
											</el-row>
											<el-row
												style="height: 40px;line-height: 40px;font-size: 15px;margin-left: 30px;">
												审批条件
											</el-row>

											<el-row style="background-color: #fdfdfd;height: 40px;">
												<el-col :span="2">&nbsp;</el-col>
												<el-col :span="20">
													<el-select @change="sptjchange(index)"
														v-model="from.sysFlowCriterias[index].approval_condition_type"
														placeholder="请选择条件" style="width: 100%;">
														<el-option v-for="approvalType in approvalTypeList"
															:key="approvalType.value" :label="approvalType.name"
															:value="approvalType.value">
														</el-option>
													</el-select>
												</el-col>
											</el-row>
											<el-row style="height: 40px;line-height: 40px;text-align: center;">
												<el-radio-group
													v-model="from.sysFlowCriterias[index].approval_criteria">
													<el-radio :label="1 + ''">大于</el-radio>
													<el-radio :label="2 + ''">小于</el-radio>
													<el-radio :label="3 + ''">等于</el-radio>
												</el-radio-group>
											</el-row>

											<el-row style="background-color: #fdfdfd;height: 40px;">
												<el-col :span="2">&nbsp;</el-col>
												<el-col :span="20">
													<el-form-item prop="ids"
														v-if="from.sysFlowCriterias[index].approval_condition_type == 1">
														<el-cascader v-model="from.sysFlowCriterias[index].ids"
															clearable placeholder="请选择架构" style="width: 100%;"
															collapse-tags :show-all-levels="false" :props="props">
														</el-cascader>
														<el-input style="margin-top: 10px;" type="textarea" :rows="2"
															disabled
															v-model="from.sysFlowCriterias[index].organizeName">
														</el-input>
													</el-form-item>
													<el-form-item prop="ids"
														v-if="from.sysFlowCriterias[index].approval_condition_type == 2">
														<el-select v-model="from.sysFlowCriterias[index].ids" multiple
															collapse-tags placeholder="请选择岗位" clearable
															style="width: 100%;">
															<el-option v-for="post in postList" :key="post.id"
																:label="post.post_name" :value="post.id">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item prop="ids"
														v-if="from.sysFlowCriterias[index].approval_condition_type == 3">
														<el-select v-model="from.sysFlowCriterias[index].ids" multiple
															collapse-tags placeholder="请选择保险类别" clearable
															style="width: 100%;">
															<el-option v-for="item in insuranceTypeList" :key="item.id"
																:label="item.data" :value="item.id">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item prop="judgment_conditions"
														v-if="from.sysFlowCriterias[index].approval_condition_type == 4">
														<el-input
															v-model="from.sysFlowCriterias[index].judgment_conditions"
															placeholder="请输入薪资" style="width: 100%;" type="number">
														</el-input>
													</el-form-item>
												</el-col>
											</el-row>
										</el-form>
									</div>
								</el-col>
								<el-col :span="8">
									<div style=" width: 90px; border: 1px #f8f8f8 solid; margin-top: 5px; margin-left: 5px; text-align: center; background-color: #fdfdfd;"
										@click="AddRecord2">
										<img style="height: 285px;width: 315px;" src="../../../../src/assets/审批+.png">
									</div>
								</el-col>
							</el-row>
						</el-tab-pane>
					</el-tabs>
				</el-row>
				<!-- </div> -->
				<el-form-item style="text-align: center; margin-top: 20px;" label-width="0px">
					<el-button type="primary" @click="Add" v-if="from.id === null || from.id === ''"
						style="width: 20%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
					<el-button type="primary" @click="Modify" v-else
						style="width: 20%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
				</el-form-item>
			</div>
		</el-form>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		props: ["data"],
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//保险类别
				insuranceTypeList: [],
				//岗位数据
				postList: [],
				//组织架构数据
				organizeList: [],
				//条件
				condition: {
					organize_ids: []
				},
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},
				activeName: 'first',
				//表单数据
				from: {
				    id: "",
				    name: "",
				    type: "",
				    state: "",
				    sysFlowDetails: [{
				        node: 0,
				        role_id: "",
				        is_leadership: 1,
				        approved_by: "",
				        ids: null
				    }],

				    sysFlowCriterias: [{
				        node: 0,
				        approval_condition_type: "1",
				        approval_criteria: "3",
				        judgment_conditions: "",
				        ids: null
				    }],

				    approvalType: [{
				        name: "",
				        value: ""
				    }],
				},

				//动态审批节点
				objestSize: [1],
				objestSize2: [1],
				//角色
				roleList: [],

				//审批条件
				approvalTypeList: [],

				//指定人
				userList: [],

				//表单验证
				rules: {
					name: [{
						required: true,
						message: '请输入审批流名称！',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择类型！',
						trigger: 'blur'
					}],
				},
				sysFlowDetailsRules: {
					ids: [{
						required: true,
						message: '请选择角色！',
						trigger: 'blur'
					}],
					approved_by: [{
						required: true,
						message: '请选择指定人！',
						trigger: 'blur'
					}],
				},
				sysFlowCriteriasRules: {
					// approval_condition_type: [{
					//     required: true,
					//     message: '请选择条件！',
					//     trigger: 'blur'
					// }],
					ids: [{
						required: true,
						message: '请选择！',
						trigger: 'blur'
					}],
					judgment_conditions: [{
						required: true,
						message: '请选择薪资！',
						trigger: 'blur'
					}]
				},
			};
		},
		methods: {
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);
			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			},
			spjdchange(index) {
				this.from.sysFlowDetails[index].ids = [];
				this.from.sysFlowDetails[index].approved_by = "";
			},
			sptjchange(index) {
				this.from.sysFlowCriterias[index].ids = [];
				this.from.sysFlowCriterias[index].judgment_conditions = "";
			},
			//添加审批节点
			AddRecord() {
				this.objestSize.push(1)
				this.$set(this.from.sysFlowDetails, this.from.sysFlowDetails.length, {
					flow_id: "",
					node: this.from.sysFlowDetails.length,
					role_id: "",
					is_leadership: 1,
					ids: null
				});
			},

			//添加审批条件
			AddRecord2() {
				this.objestSize2.push(1)
				this.$set(this.from.sysFlowCriterias, this.from.sysFlowCriterias.length, {
					node: this.from.sysFlowCriterias.length,
					approval_condition_type: "1",
					approval_criteria: "3",
					judgment_conditions: "",
					ids: null
				});
			},
			//移除审批节点
			RemoveRecord(e) {
				this.objestSize.splice(e, 1);
				this.from.sysFlowDetails.splice(e, 1);
			},
			//移除审批条件
			RemoveRecord2(e) {
				this.objestSize2.splice(e, 1);
				this.from.sysFlowCriterias.splice(e, 1);
			},
			//添加
			Add() {
				this.$refs["from"].validate((valid) => {
					if (valid) {
						const url = this.$globals.http + "flow/add";

						this.from.sysFlowCriterias.forEach(item => {
							if (item.approval_condition_type == 1) {
								var temporary = [];
								item.ids.forEach(id => {
									temporary.push(id[id.length - 1])
								})
								item.ids = temporary;
							}
						})

						axios.post(url, {
							name: this.from.name,
							type: this.from.type,
							sysFlowDetails: this.from.sysFlowDetails,
							sysFlowCriterias: this.from.sysFlowCriterias
						}).then((response) => {
							var code = response.data.code;
							var data = response.data.data;

							if (code === '200') {

								this.$message.success(data);
								this.Return();

							} else {
								this.$message.warning(data);
							}
						}).catch((error) => {
							console.log(error)
							this.$message.error("服务器未响应！请稍后重试");
						})
					}
				});
			},
			//修改
			Modify() {
				this.$refs["from"].validate((valid) => {
					if (valid) {
						const url = this.$globals.http + "flow/modify";

						this.from.sysFlowCriterias.forEach(item => {

							if (item.approval_condition_type == 1 && item.ids.length > 0 && Array.isArray(
									item.ids[0])) {
								var temporary = [];
								item.ids.forEach(id => {
									temporary.push(id[id.length - 1])
								})
								item.ids = temporary;
							}

						})

						axios.post(url, {
							id: this.from.id,
							name: this.from.name,
							type: this.from.type,
							sysFlowDetails: this.from.sysFlowDetails,
							sysFlowCriterias: this.from.sysFlowCriterias
						}).then((response) => {
							var code = response.data.code;
							var data = response.data.data;

							if (code === '200') {

								this.$message.success(data);
								this.Return();

							} else {
								this.$message.warning(data);
							}
						}).catch((error) => {
							console.log(error)
							this.$message.error("服务器未响应！请稍后重试");
						})
					}
				});
			},
			//返回
			Return() {
				this.$parent.$parent.Return();
			},
			//清除
			trash() {
				this.from = {
					id: "",
					name: "",
					type: "",
					state: "",
					sysFlowDetails: [{
						flow_id: "",
						node: 0,
						role_id: "",
						is_leadership: 1,
						approved_by: "",
						ids: null
					}],
					sysFlowCriterias: [{
						node: 0,
						approval_condition_type: "1",
						approval_criteria: "3",
						judgment_conditions: "",
						ids: null
					}]
				};
			},
		},
		async created() {
			//初始化角色下拉
			var roleList = await this.$globals.AxiosPost("role/selectFind", {});
			this.roleList = roleList.data;

			//初始化审批条件下拉
			var approvalTypeList = await this.$globals.AxiosGet("flow/approvalType");
			this.approvalTypeList = approvalTypeList.data;

			var userList = await this.$globals.AxiosPost("user/selectFind", {});
			this.userList = userList.data;

			this.organizeFind();

			var postList = await this.$globals.AxiosPost('post/selectFind', {});
			this.postList = postList.data;

			//初始化保险类别
			var insuranceTypeList = await this.$globals.AxiosPost("dictionaries/selectFind", {
				data_grouping: "insurance_type"
			});
			this.insuranceTypeList = insuranceTypeList.data;
		},
		watch: {
			"data"(newVal) {
				// this.from = newVal;
			}
		}
	}
</script>

<style scoped="scoped">
	>>>.el-tabs__item.is-active {
		color: #006E4B;
	}

	>>>.el-tabs__active-bar {
		background-color: #006E4B;
	}

	>>>.el-tabs__item {
		font-size: 17px;
	}

	>>>.el-tabs__item:hover {
		color: #006E4B;
	}

	>>>.el-tabs__nav {
		margin-left: 60px;
	}

	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// Flow_add.vue?835d9920